
















import {Component, Prop, Watch, Vue} from 'vue-property-decorator';

@Component({
    inheritAttrs: false,
})
export default class CTextField extends Vue {
    @Prop({required: true}) value!: string | null;
    @Prop({default: true, type: Boolean}) showChangeState!: boolean;
    @Prop() initialValue!: number | undefined;
    @Prop() rules!: any[];
    @Prop({default: 'plywood lighten-1', type: String}) color!: string;
    @Prop() errorKey!: string;
    @Prop() errors!: any;

    private localInitialValue: string | null = null;
    private errorMsg: string | null = null;

    get inputTextClasses() {
        const classes: string[] = [];
        if (this.realInitialValue != this.value && this.showChangeState) classes.push('changed');
        return classes;
    }

    get listeners() {
        return Object.assign({}, this.$listeners, {
            input: (value: any) => this.$emit('input', value),
            change: (value: any) => this.$emit('input', value),
        });
    }

    get realInitialValue() {
        return typeof this.initialValue != 'undefined' ? this.initialValue : this.localInitialValue;
    }

    get realRules() {
        return this.rules
            ? this.rules
            : [
                  (v: any) =>
                      /^[А-ЯЁа-яёЁA-Za-z0-9/(/)""/%№+-]+[А-ЯЁа-яёЁA-Za-z0-9/(/)""\s/%№+-]*$/.test(v) ||
                      this.$t('Common.Messages.AlphaNumericExpression'),
              ];
    }

    @Watch('errors', {deep: true})
    onErrorsChange(value: any) {
        if (!this.errorKey) return console.warn('please provide error-key');
        if (this.errorKey in value) {
            this.errorMsg = value[this.errorKey][0];
        } else {
            this.errorMsg = null;
        }
    }

    @Watch('value')
    onValueChange(value: string) {
        if (this.errorMsg) this.errorMsg = null;
    }

    created() {
        this.localInitialValue = this.value;
    }
}
